import{cancelFrame as e,frame as r}from"../../../frameloop/frame.mjs.js";function t(t,o){let n;const m=()=>{const{currentTime:e}=o,r=(null===e?0:e.value)/100;n!==r&&t(r),n=r};return r.update(m,!0),()=>e(m)}export{t as observeTimeline};
